import { useEffect, useRef } from 'react';
import { useConvexAuth } from 'convex/react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../../../reactvideoeditor/pro/components/ui/dialog';
import { SignInForm } from '../../SignInForm';

interface AuthModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAuthenticated: () => void;
}

export function AuthModal({ open, onOpenChange, onAuthenticated }: AuthModalProps) {
  const { isAuthenticated } = useConvexAuth();
  const wasOpen = useRef(false);

  useEffect(() => {
    if (open) {
      wasOpen.current = true;
    }
  }, [open]);

  // Auto-close and trigger callback when user authenticates
  useEffect(() => {
    if (isAuthenticated && wasOpen.current) {
      wasOpen.current = false;
      onOpenChange(false);
      onAuthenticated();
    }
  }, [isAuthenticated, onOpenChange, onAuthenticated]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Sign in to process your video</DialogTitle>
          <DialogDescription>
            Create a free account to continue
          </DialogDescription>
        </DialogHeader>
        <SignInForm />
      </DialogContent>
    </Dialog>
  );
}
